const AnesthesiaSelector = ({
    label,
    name,
    options,
    selectedValues = [],
    onChange,
    disabled = false,
    required = false
}) => {
    const handleToggle = (value) => {
        const newValues = selectedValues.includes(value)
            ? selectedValues.filter(v => v !== value)
            : [...selectedValues, value];
        onChange(newValues);
    };

    return (
        <div className="mb-4">
            <label className="block text-base font-medium text-gray-700 mb-3">
                {label}
                {required && <span className="text-red-600 ml-1">*</span>}
            </label>
            <div className="flex flex-wrap gap-3">
                {options.map((option) => (
                    <button
                        key={option.value}
                        type="button"
                        onClick={() => handleToggle(option.value)}
                        disabled={disabled}
                        className={`
                            px-4 py-2 rounded-md text-sm font-medium
                            transition-all duration-200
                            border-2
                            ${
                                selectedValues.includes(option.value)
                                    ? 'bg-blue-600 border-blue-600 text-white'
                                    : 'bg-white border-gray-300 text-gray-700 hover:border-blue-500'
                            }
                            ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
                        `}
                    >
                        {option.label}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default AnesthesiaSelector;
